export function stripTags(str, replace_with='') {
  return str.replace(/<\/?[^>]+(>|$)/g, replace_with)
}

export function replaceLast(text, find, replace) {
  let index = text.lastIndexOf(find)

  if (index >= 0) {
    return (
      text.substring(0, index) + replace + text.substring(index + find.length)
    )
  }

  return text.toString()
}
